import api from "@/core/services/api.service";

const PersonService = {

    PoomDan(params) {
        api.setHeader()
        return api.post("api/person/poomdanes", params)
    }
    /*save(params) {
        api.setHeader()
        return api.post("api/person/save", params)
    },*/
}

export default PersonService